import { useCallback } from 'react';
import ReactGA from 'react-ga4';
import { useApplicationParams } from '../../context';
import { amplitude } from '../../amplitude';

export const useEventTracker = () => {
  const { platform } = useApplicationParams();

  const trackEvent = useCallback(
    (event, data = {}) => {
      const eventData = {
        ...data,
        platform,
      };

      window.trackEvent(event, eventData);
      ReactGA.event(event, eventData);
      amplitude.getInstance().logEvent(event, eventData);
      window.Insider?.track('events', [
        {
          event_name: event,
          event_params: eventData,
        },
      ]);
    },
    [platform],
  );

  return trackEvent;
};
